import DocumentoFirmatoValidoController from "./doc_valido/DocumentoFirmatoValidoController";
import DocumentoFirmatoNonValidoController from "./doc_non_valido/DocumentoFirmatoNonValidoController";
import React, {Fragment} from "react";

export default function VerificaDocumentoView({
                                                  documento,
                                              }) {

    return (
        <Fragment>
            <div className={"row"}>
                <div className={"col-md-12 text-center"}>
                    <h6>Via Cesare Battisti, 2 - 10123 Torino</h6>
                    <h6>TEL. +39 011-5629881</h6>
                    <h6>EMAIL info@registrofiat.it</h6>
                </div>

                {
                    documento && documento.veicolo ?
                        <DocumentoFirmatoValidoController
                            documento={documento}
                        />
                        :
                        <DocumentoFirmatoNonValidoController/>
                }
            </div>
        </Fragment>
    );

}